<template>
  <!-- Container -->
  <div class="w-11/12 mx-auto">
    <h2 class="big-title mb-14">
      Restaurant
    </h2>
    <!-- Form container -->
    <div class="form-wrapper 2xl:w-9/12 mx-auto">
      <h3 class="form-title">
        Create Table placement
      </h3>

      <!-- Form -->
      <form @submit.prevent="onSubmit" class="text-tableSubColor font-bold">
        <div class="md:flex">
          <!-- Table name -->
          <div class="w-full mb-4 md:mr-8">
            <label
              >Table name
              <input
                type="text"
                name="tableName"
                autocomplete="off"
                v-model="model.table_name"
                class="input"
                :class="{
                  'is-invalid': v$.model.table_name.$error,
                }"
              />
            </label>
            <span
              v-if="v$.model.table_name.$error"
              class="text-sm font-normal text-invalidColor"
              >{{ v$.model.table_name.$errors[0].$message }}</span
            >
          </div>
          <!-- Table number -->
          <div class="w-full mb-4">
            <label
              >Table number
              <input
                type="text"
                name="tableName"
                autocomplete="off"
                v-model="model.table_number"
                class="input"
                :class="{
                  'is-invalid': v$.model.table_number.$error,
                }"
              />
            </label>
            <span
              v-if="v$.model.table_number.$error"
              class="text-sm font-normal text-invalidColor"
              >{{ v$.model.table_number.$errors[0].$message }}</span
            >
          </div>
        </div>

        <!-- Buttons -->
        <div class="w-full flex justify-end pt-4">
          <Button
            type="button"
            @click.prevent="back"
            btnTitle="Cancel"
            class="mr-4 bg-goldBeige text-black"
          />
          <Button type="submit" btnTitle="Save" class="bg-greenBtn" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TablePlacementCreate",
  components: {
    Button,
  },
  data() {
    return {
      v$: useVuelidate(),
      model: {
        table_name: "",
        table_number: "",
      },
    };
  },

  /* --- Validation --- */
  validations() {
    return {
      model: {
        table_name: { required },
        table_number: { required },
      },
    };
  },

  async beforeMount() {
    if (this.getTables.length == 0) {
      await this.fetchTables;
    }
    this.getCurrentTable();
  },

  computed: {
    ...mapGetters(["getTableById", "getTables"]),
    ...mapActions(["fetchTables"]),
  },

  methods: {
    getCurrentTable() {
      let id = parseInt(this.$route.params.id);
      this.model = this.getTableById(id)[0];
    },

    async onSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        try {
          await this.$store.dispatch("patchTable", this.model);
          //redirect
          this.$router.push("/table-placement");
        } catch (e) {
          alert(Object.values(e.response.data.messages).join(" "));
        }
      }
    },

    back() {
      this.$router.go(-1);
    },
  },
};
</script>
